<template>
    <div class="fixed-footer">
        <div class="content_wrap">
            <p>
                <!-- <span>（总部）延安西路200号1号楼1104室</span>
                <span>邮编：200040</span>
                <span>电话：52353720</span>
                <span>邮箱：shuxiegongzuo@163.com</span> -->
                <span>{{ tougaoSetting.organizer_address }}</span>
            </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Footer',
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters([
            'tougaoSetting'
        ])
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.fixed-footer{
  // position: fixed;
  // bottom: 0;
  // right: 0;
  z-index: 9;
  width: 100%;
  background: #282828;
  -webkit-transition: width 0.28s;
  transition: width 0.28s;

  .content_wrap {
    height: 80px;
    line-height: 80px;
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    position: relative;

    p{
      font-size: 14px;
      color: #fff;
      line-height: 80px;
    }
  }
}
</style>
